// services/authApi.ts
import apiClient from "./apiClient";

export interface Organization {
  id: number;
  name: string;
  businessType: string;
  gstin: string;
  address: string;
  state: string;
  district: string;
  pincode: string;
}

export interface User {
  id: number;
  ownerName: string;
  email: string;
  userType: string; // "Owner" or "Employee"
  userTypeId?: number;
  organization: Organization;
}

export interface LoginResponse {
  message: string;
  token: string;
  user: User;
}

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>("/auth/login", {
      email,
      password,
    });
    return response.data;
  },
};
